import { useSelector } from 'react-redux';
import { RootState } from '../../../../reducer';
import { heatmapLegend } from '../../../../shared/constants';
import { buildHeatmapLegend } from '../../heatmap/Factory/heatmap.factory';
import Legend from '../legend';
import './heatmaLegend.scss';

function HeatmapLegend() {
  const { type } = useSelector((state: RootState) => state.heatmap);
  const { menuAction } = useSelector(
    (state: RootState) => state.dashboardState.isActive
  );

  const isPrimaryMarket = menuAction === '1';

  return (
    <>
      <h2>{type === 'price' ? 'Preço do m²' : 'Quantidade de oferta'}</h2>
      <div className="layers-legends-heatmap-container">
        {heatmapLegend.map((color) => {
          return (
            <Legend
              text={buildHeatmapLegend(color, isPrimaryMarket)}
              bgColor={color}
              key={crypto.randomUUID()}
              displayIcon={false}
            />
          );
        })}
      </div>
    </>
  );
}

export default HeatmapLegend;
